export default __webpack_public_path__ + "static/media/message-icon.d4e44005.svg";